import { effect as l, setAttribute as s, template as c } from "solid-js/web";
var i = c('<svg xmlns=http://www.w3.org/2000/svg width=24 height=24 viewBox="0 0 256 256"data-scope=button data-part=icon><path d=M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z>');
const n = (e) => {
  return a = i(), l((t) => {
    var r = e.color || "currentColor", o = e.class;
    return r !== t.e && s(a, "fill", t.e = r), o !== t.t && s(a, "class", t.t = o), t;
  }, { e: void 0, t: void 0 }), a;
  var a;
};
export {
  n as PrevIcon
};
